import React from 'react';

import { Box, List, ListItem, makeStyles, Typography } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';

type GameSpec = { id: string; label: string; value: string };

export interface SpecificationsProps {
  items: GameSpec[];
}

const useStyle = makeStyles(theme => ({
  label: { width: 100 },
  value: { flexGrow: 1 },
  list: { padding: 0 },
  container: {
    display: 'flex',
    height: 52,
    alignItems: 'center',
    borderBottom: `1px solid ${theme.palette.grey['300']}`,
  },
}));

const SpecItem = ({ label, value }: GameSpec) => {
  const classes = useStyle();
  return (
    <ListItem className={classes.container} data-testid="specification-item" disableGutters>
      <Typography className={classes.label} variant="body2" color="textSecondary">
        {label}
      </Typography>
      <Typography className={classes.value} variant="body2" color="textPrimary">
        {value}
      </Typography>
    </ListItem>
  );
};

const Specifications = ({ items }: SpecificationsProps) => {
  const classes = useStyle();
  return (
    <Box display="flex" flexDirection="column">
      <Typography variant="h6">
        <FormattedMessage id="game.details.about.details" />
      </Typography>
      <List className={classes.list}>
        {items.map(spec => (
          <SpecItem key={spec.id} {...spec} />
        ))}
      </List>
    </Box>
  );
};

export default Specifications;
